var map = {
	"./Dark-theme.png": "bf13",
	"./DefIMG_Prod_DK.svg": "ec48",
	"./DefIMG_Prod_LT.svg": "e31a",
	"./DefIMG_StoreLogo.svg": "5e6e",
	"./Icon_ZWING_offline.svg": "2b61",
	"./Light-theme.png": "7752",
	"./Logout-white.svg": "325f",
	"./Logout.svg": "4067",
	"./Scan.svg": "55f8",
	"./add.png": "fbc1",
	"./add.svg": "24e9",
	"./add_green.svg": "009e",
	"./add_grey.svg": "8654",
	"./add_phone.svg": "ebe6",
	"./airtel_long.png": "eba4",
	"./alert.svg": "49bb",
	"./amazonpay_long.png": "5401",
	"./arrowBack@2x.png": "901a",
	"./arrowBack@3x.png": "b6e0",
	"./arrow_back.svg": "1a2c",
	"./barcode.svg": "c72c",
	"./big_tick.svg": "a37f",
	"./billing.svg": "be94",
	"./card-dark.svg": "e06c",
	"./card.svg": "3522",
	"./cash-dark.svg": "452a",
	"./cash-drawer.svg": "4e59",
	"./cash.svg": "bcbc",
	"./checkbox_off.svg": "aed7",
	"./checkbox_on.svg": "ea3d",
	"./citrus_long.svg": "96d6",
	"./close_session.svg": "4386",
	"./downloading.svg": "ad95",
	"./food-delivery.svg": "3c50",
	"./freecharge_long.png": "c58b",
	"./gift_voucher.svg": "b8ee",
	"./giftvoucher.svg": "3f63",
	"./go-back-left-arrow.svg": "4435",
	"./google_pay_long.svg": "c43b",
	"./googlepay.svg": "d093",
	"./green-add.svg": "bc1c",
	"./hide-small.svg": "2ea1",
	"./home.svg": "c6c2",
	"./icon_info.svg": "18d4",
	"./icon_notif.svg": "65cf",
	"./icon_request.svg": "ad36",
	"./icon_skip.svg": "8f72",
	"./icon_success.svg": "cd14",
	"./icon_success_color.svg": "6d5a",
	"./iconfinder-icon.svg": "a398",
	"./iconfinder_user.svg": "58ee",
	"./img.png": "7f53",
	"./img.svg": "4b72",
	"./info.svg": "db39",
	"./inventory.svg": "3ac8",
	"./invoices.svg": "21a4",
	"./kboard.svg": "f511",
	"./kboard_ffffff.svg": "8d10",
	"./keyboard.svg": "d7ed",
	"./mCSB_buttons.png": "a11a",
	"./mobikwik_long.svg": "f337",
	"./no-img-lg.png": "bec1",
	"./no-img.svg": "c4e0",
	"./ola_long.png": "b0df",
	"./payments_phonepe_light.svg": "31bc",
	"./paypal_long.svg": "0cec",
	"./paytm.svg": "c6ea",
	"./paytm_long.svg": "9411",
	"./payu_long.svg": "1bb2",
	"./phone_added.svg": "3761",
	"./phonepe_dark.png": "6a33",
	"./phonepe_light.png": "d88a",
	"./phonepe_long.svg": "7107",
	"./pinelabs_dark.png": "33a1",
	"./pinelabs_light.png": "b10a",
	"./printer.svg": "75d6",
	"./profile.svg": "c768",
	"./remove-discount.svg": "8693",
	"./remove.svg": "f08b",
	"./return.svg": "5f26",
	"./reveal-small.svg": "43d2",
	"./rupee.png": "c59e",
	"./rupee.svg": "3de7",
	"./settings.svg": "09a5",
	"./start_session.png": "2f19",
	"./start_session.svg": "e2d4",
	"./subtract.png": "1186",
	"./subtract.svg": "7993",
	"./success.svg": "0bf4",
	"./upi_long.svg": "8b94",
	"./windows.svg": "b9a2",
	"./zg-logo.svg": "9703",
	"./zw-gift-card.svg": "bcac",
	"./zw-orders.svg": "e35a",
	"./zwingBlack.svg": "c1db",
	"./zwing_default.png": "e981",
	"./zwing_default_dark.png": "9458"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";